import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const m = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: t, disableSSR: d, style: r, ...h }) => {
  const p = r ? { ...m, ...r } : m;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-mingwendaohang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...h }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-é­æå¯¼èª"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? i(c, 0, "#262933") : "#262933",
        datafollowfill: l ? i(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M2.937 11.996a8.275 8.275 0 0 1 16.55 0 .8.8 0 0 0 1.6 0c0-5.454-4.42-9.875-9.875-9.875-5.453 0-9.875 4.421-9.875 9.875s4.422 9.875 9.875 9.875a.8.8 0 0 0 0-1.6 8.275 8.275 0 0 1-8.275-8.275Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9.813 9.134a3.509 3.509 0 0 1 3.417.811 3.509 3.509 0 0 1 1.007 3.365.8.8 0 1 0 1.557.368 5.109 5.109 0 0 0-1.466-4.896 5.109 5.109 0 0 0-4.972-1.18.8.8 0 0 0 .457 1.532Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12.473 10.617a.8.8 0 0 1 .049 1.13L8.834 15.77a.8.8 0 0 1-1.18-1.08l3.688-4.024a.8.8 0 0 1 1.13-.05Zm4.102 4.837a.75.75 0 1 0 0 1.5h4.538a.75.75 0 0 0 0-1.5h-4.538Zm-1.987 3.225a.75.75 0 0 1 .75-.75h5.775a.75.75 0 0 1 0 1.5h-5.775a.75.75 0 0 1-.75-.75Zm.75 1.725a.75.75 0 1 0 0 1.5h5.775a.75.75 0 0 0 0-1.5h-5.775Z"
        }
      )
    )
  )));
}, w = x;
export {
  w as default
};
